// extracted by mini-css-extract-plugin
export default {"container":"Brands_container__92rbR","card":"Brands_card__0lQMf"};